import Input from 'antd/lib/input';

const { TextArea: AntTextArea } = Input;

export const TextArea = AntTextArea;
